export type Breakpoints = [number, number][];

export const createBreakpoints = (): Breakpoints => {
  const breakpoints: Breakpoints = [
    [0, 2],
    [500, 2.5],
    [650, 3],
    [800, 5],
  ];

  for (let i = 0; i < 50; i++) {
    const [previousWidth, previousSlidesToShow] =
      breakpoints[breakpoints.length - 1];

    breakpoints.push([previousWidth + 100, previousSlidesToShow + 1]);
  }

  return breakpoints;
};
